module.exports = __webpack_public_path__ + "img/gal_35.ec62ffc4.png";